export const API_EXTERNAL_ENDPOINT = 'vacaciones-landings/:slug'

export const API_INTERNAL_ENDPOINT = 'strapi/vacaciones-landings/detail'
